// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-content {\n  height: 100vh;\n  padding-top: 80px; }\n", "",{"version":3,"sources":["webpack://./src/caster-animation/main-content/MainContent.scss"],"names":[],"mappings":"AACA;EACI,aAAa;EACb,iBAAiB,EAAA","sourcesContent":["\n.main-content {\n    height: 100vh;\n    padding-top: 80px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
